import { colors } from "widgets/utils";

import { useGenomeViewerStore } from "../../store/store.ts";
import type { MainThreadHoverMessage } from "../../types.ts";
import { alignToLeftPixelGrid } from "../../utils/graphics/align-to-pixel-grid.ts";
import { getTrackOffsetY } from "../../utils/graphics/track-offset.ts";

/**
 * We render the hover effect on the main thread.
 * It will prevent to render tracks all the time.
 * It will also prevent having multiple hover at the same time - In case a rendering fails or mouse event are not detected, etc.
 */
export function drawHover(
  data: Pick<MainThreadHoverMessage, "id" | "trackId" | "x" | "y" | "width" | "height">,
  filled = false,
) {
  const { ctx, scrollY, trackGroups, tracks } = useGenomeViewerStore.getState();

  if (ctx && data?.id && data?.trackId) {
    const offsetY = getTrackOffsetY(trackGroups, tracks, data.trackId);
    const { height, width, y, x } = data;

    if (ctx) {
      ctx.save();
      if (filled) {
        ctx.fillStyle = colors.selectStroke;
        ctx.globalAlpha = 0.15;
        ctx.fillRect(x! - 2, offsetY + y! - 2 - scrollY, width! + 4, height! + 4);
      } else {
        ctx.lineWidth = 1;
        ctx.strokeStyle = colors.selectStroke;
        ctx.strokeRect(
          alignToLeftPixelGrid(x! - 2),
          alignToLeftPixelGrid(offsetY + y! - 2 - scrollY),
          width! + 3,
          height! + 3,
        );
      }

      ctx.restore();
    }
  }
}
